import { render, staticRenderFns } from "./LpuPromotions.vue?vue&type=template&id=4141b01b&scoped=true&"
import script from "./LpuPromotions.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LpuPromotions.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./LpuPromotions.vue?vue&type=style&index=0&id=4141b01b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4141b01b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4141b01b')) {
      api.createRecord('4141b01b', component.options)
    } else {
      api.reload('4141b01b', component.options)
    }
    module.hot.accept("./LpuPromotions.vue?vue&type=template&id=4141b01b&scoped=true&", function () {
      api.rerender('4141b01b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuPromotions/LpuPromotions.vue"
export default component.exports